export const boldSearchText = (searchText: string, text: string) => {
  if (!searchText) return text; // nothing to highlight

  // Escape special regex characters in the search term
  const escapedSearch = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create a case-insensitive global regex safely
  const regex = new RegExp(`(${escapedSearch})`, 'gi');

  // Escape HTML in the original text to prevent XSS
  const escapeHTML = (str: string) =>
    str.replace(/[&<>"']/g, (m) => {
      const map: Record<string, string> = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };
      return map[m];
    });

  const safeText = escapeHTML(text);

  // Apply highlighting using safe replacement
  return safeText.replace(regex, '<span class="font-bold">$1</span>');
};
